export default __webpack_public_path__ + "static/china-results-1-65ed8dcf41c047e51baca5d97e9c9720.png";